import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { syncOfflineData } from './utils/offlineSync';

if (navigator.onLine) {
  syncOfflineData();
}

window.addEventListener('online', () => {
  syncOfflineData();
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
